export default "__VITE_ASSET__BvwmQ_ym__"